/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import router from "../router";

const actions = {
  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth({ commit }, width) {
    commit("UPDATE_VERTICAL_NAV_MENU_WIDTH", width);
  },

  // VxAutoSuggest
  updateStarredPage({ commit }, payload) {
    commit("UPDATE_STARRED_PAGE", payload);
  },

  // The Navbar
  arrangeStarredPagesLimited({ commit }, list) {
    commit("ARRANGE_STARRED_PAGES_LIMITED", list);
  },
  arrangeStarredPagesMore({ commit }, list) {
    commit("ARRANGE_STARRED_PAGES_MORE", list);
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay({ commit }) {
    commit("TOGGLE_CONTENT_OVERLAY");
  },
  updateTheme({ commit }, val) {
    commit("UPDATE_THEME", val);
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  /*updateUserInfo({ commit }, payload) {
    commit('UPDATE_USER_INFO', payload)
  },*/
  initAuth({ commit }) {
    //alert(info)
    if (localStorage.getItem("tokenId")) {
      //  let veriler = JSON.parse(localStorage.getItem('userInfo'))
      //commit('setToken',veriler[0])
      //router.push('/')
    } else {
      router.push("/login");
    }
  },
  login({ commit, state }, payload) {
    //console.log(payload.userDetails.email
    var serviceAddressOnline = "";
    var vm = this;
    var vs = payload.vs;
    const soap = require("soap");
    const data = [];

    // const urlOnline='http://service.uzum.com.tr/loginService.php?wsdl'

    const argsOnline = {
      companyId: payload.userDetails.bayikodu,
      userName: payload.userDetails.email,
      password: payload.userDetails.password
    };
    soap.createClient(
      state.loginServiceUrl,
      //"http://www.service.uzum.com.tr/loginService.php?wsdl",
      //"https://localhost:7158/loginService.asmx?wsdl",
      function (err, client) {
        //  soap.createClient('https://www.servicessl.uzum.com.tr/loginService.php?wsdl', function(err, client){
        client.addHttpHeader("Access-Control-Allow-Origin", "*");
        client.addHttpHeader("Access-Control-Allow-Methods", "GET, POST, PATCH, PUT, DELETE, OPTIONS");
        client.addHttpHeader("Access-Control-Allow-Headers", "*");


        client.loginService(argsOnline, function (err, result) {
          //  console.log(JSON.stringify(result))

          vm.verilers = JSON.parse(JSON.stringify(result));
          // console.log(vm.verilers.return.$value)
          vm.veriler = JSON.parse(vm.verilers.return.$value); 
          if (vm.veriler != "-1") {
            // vm.veriler=JSON.parse('[{"id":"5","adSoyad":"Serkan \u00d6ZBEK","kullaniciAdi":"serkan","sifre":"d0970714757783e6cf17b26fb8e2298f","plasiyer":"1","sonGiris":"2020-12-05 06:42:19","servisAdresi":"http:\/\/localhost\/servisler\/sistem.asmx?WSDL","printAddress":"http:\/\/localhost\/servisler\/fatura\/fatura.aspx?Id=","grupKod":"SER"}]')
            serviceAddressOnline =  vm.veriler[0].servisAdresi////
            data["servisAdresi"] = vm.veriler[0].servisAdresi//"http://localhost:44353/sistem.asmx?WSDL"//
            data["id"] = vm.veriler[0].kid;
            data["musteriId"] = vm.veriler[0].id;
            data["adSoyad"] = vm.veriler[0].adSoyad;
            data["firmaAdi"] = vm.veriler[0].firmaAdi;
            data["plasiyer"] = vm.veriler[0].plasiyer;
            data["printAddress"] = vm.veriler[0].printAddress;
            data["printAddress2"] = vm.veriler[0].printAdress2;
            data["grupKod"] = vm.veriler[0].grupKod;
            data["yetkiTipi"] = vm.veriler[0].yetkiTipi;
            data["ekAlan1"] = vm.veriler[0].ekAlan1;
            data["moduller"] = vm.veriler[0].moduller;
            data["crmCustomerCode"] = vm.veriler[0].crmCustomerCode;
            data["crmApi"] = "https://uzmff.g4full.com/uzumcore7app/";




            localStorage.setItem("servisAdresi", vm.veriler[0].servisAdresi);
            localStorage.setItem("id", vm.veriler[0].kid);
            localStorage.setItem("musteriId", vm.veriler[0].id);
            localStorage.setItem("adSoyad", vm.veriler[0].adSoyad);
            localStorage.setItem("firmaAdi", vm.veriler[0].firmaAdi);
            localStorage.setItem("plasiyer", vm.veriler[0].plasiyer);
            localStorage.setItem("printAddress", vm.veriler[0].printAddress);
            localStorage.setItem("printAddress2", vm.veriler[0].printAddress2);
            localStorage.setItem("grupKod", vm.veriler[0].grupKod);
            localStorage.setItem("yetkiTipi", vm.veriler[0].yetkiTipi);
            localStorage.setItem("ekAlan1", vm.veriler[0].ekAlan1);
            localStorage.setItem("moduller", vm.veriler[0].moduller);
            localStorage.setItem("crmCustomerCode", vm.veriler[0].crmCustomerCode);
            localStorage.setItem("crmApi",  data["crmApi"]);



            // alert(vm.veriler[0].ipne)

            //console.log(vm.veriler)

            const url = serviceAddressOnline;
            const args = {
              firmaKodu: payload.userDetails.bayikodu,
              userName: payload.userDetails.email,
              password: payload.userDetails.password
            };
            soap.createClient(url, function (err, client1) {
              //  client.addHttpHeader('User-Agent', `CustomUserAgent`);
              /*
              client1.addHttpHeader("Access-Control-Allow-Origin", "*");
              client1.addHttpHeader("Access-Control-Allow-Methods", "*");
              client1.addHttpHeader("Access-Control-Allow-Headers", "*");*/
              client1.kullaniciGirisiOnline(args, function (err, result) {
                vm.veriler = JSON.parse(result.kullaniciGirisiOnlineResult);
                //  console.log(vm.veriler)
                if (vm.veriler == "-1") {
                  vs.notify({
                    title: "Hatalı Giriş 2222",
                    text: "Hatalı",
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "danger"
                  });
                } else {
                  vs.notify({
                    title: "Giriş Başarılı",
                    text: "Lütfen Bekleyin Yönlendirileceksiniz.",
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "success"
                  });
                  //alert(vm.veriler[0])
                  data["tokenId"] = vm.veriler[0].tokenId;
                  data["ekYetkiler"] = vm.veriler[0].ekYetkiler;                 
                  data["sube"] = vm.veriler[0].sube;

                  localStorage.setItem("tokenId", vm.veriler[0].tokenId);
                  localStorage.setItem("ekYetkiler", vm.veriler[0].ekYetkiler);

                  localStorage.setItem("sube", vm.veriler[0].sube); 

                  localStorage.setItem(
                    "userInfo",
                    result.kullaniciGirisiOnlineResult
                  );
                  commit("setToken", data);

                  // localStorage.setItem('plasiyer',vm.veriler[0].plasiyer)
                  // localStorage.setItem('serkan',vm.veriler[0].id)
                  // console.log(vm.veriler[0].plasiyer)
                }
                router.push("/");
              });
            });
          } else {
            vs.notify({
              title: "Hatalı Giriş",
              text: "Hatalı",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger"
            });
          }
        });
      }
    );
  },
  logout({ commit }) {
    commit("clearToken");
    router.push("/login");
  }
};

export default actions;
